

















import Modal from "@/misc/Modal.vue"
import {defineComponent, ref} from "@vue/composition-api"
import axios from "axios"
import {env} from "@/environment"
import {useToast} from "vue-toastification/composition"

export default defineComponent({
  name: 'Feedback',
  components: {Modal},
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  setup(props, {emit}) {
    const toast = useToast()
    const form = ref({
      email: '',
      text: '',
    })

    async function onFormSubmit() {
      console.log('Sending feedback!')
      try {
        const response = await axios.post(`${env.backendUrl}/feedback`, form.value)
        toast.success('Thank you for your feedback :)')
      } catch (e) {
        toast.error('Sorry, there was a problem sending the feedback :(')
        throw e
      }
      emit('close')
    }

    return { form, onFormSubmit }
  }
})
